import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=f28428ea&scoped=true&"
import script from "./Upload.vue?vue&type=script&lang=js&"
export * from "./Upload.vue?vue&type=script&lang=js&"
import style0 from "./Upload.vue?vue&type=style&index=0&id=f28428ea&scoped=true&lang=css&"
import style1 from "./Upload.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28428ea",
  null
  
)

export default component.exports